import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

import data from '../_data/activityAndMovementIntegrationsData';

const ActivityAndMovementIntegrations = () => {
  return (
    <section
      className="z-10 py-20 text-brown-500"
      data-cy="activity-and-movement-integrations"
    >
      <LandingPageIntegrations
        description="activity_integrations_copy"
        logoColor="black"
        integrations={data}
        title="activity_integrations_title"
        className="text-brown-500"
      />
    </section>
  );
};

export default ActivityAndMovementIntegrations;
